import { toast } from "sonner";

const LOGO_LOCAL = "/nexto-logo.png";
const loadImage = (src) => new Promise((res) => { const i = new Image(); i.onload = () => res(i); i.onerror = () => res(null); i.src = src; });

// Generates a branded "Player of the Week" social card and opens a viewer with Save / Share / Close.
export async function openPotwCard({ name, points = 0, streak = 0, weekOf = "" }) {
  const logo = await loadImage(LOGO_LOCAL);
  const W = 1080, H = 1080;
  const c = document.createElement("canvas"); c.width = W; c.height = H;
  const ctx = c.getContext("2d");
  const g = ctx.createRadialGradient(W / 2, -80, 80, W / 2, 300, H);
  g.addColorStop(0, "#241a06"); g.addColorStop(0.5, "#120d03"); g.addColorStop(1, "#0a0a0a");
  ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
  // gold frame
  ctx.strokeStyle = "#D4AF37"; ctx.lineWidth = 6; ctx.strokeRect(40, 40, W - 80, H - 80);
  ctx.textAlign = "center";
  if (logo) ctx.drawImage(logo, W / 2 - 85, 90, 170, 170);
  ctx.fillStyle = "#D4AF37"; ctx.font = "800 34px Arial, sans-serif";
  ctx.fillText("🏆  PLAYER OF THE WEEK", W / 2, 330);
  ctx.fillStyle = "#9a9a9a"; ctx.font = "400 26px Arial, sans-serif";
  if (weekOf) ctx.fillText(`Week of ${weekOf}`, W / 2, 375);
  // name (auto-fit)
  ctx.fillStyle = "#ffffff"; let size = 96; const nm = (name || "").toUpperCase();
  ctx.font = `800 ${size}px Arial, sans-serif`;
  while (size > 48 && ctx.measureText(nm).width > W - 160) { size -= 4; ctx.font = `800 ${size}px Arial, sans-serif`; }
  ctx.fillText(nm, W / 2, 560);
  // stat chip
  ctx.fillStyle = "#D4AF37"; ctx.font = "800 40px Arial, sans-serif";
  ctx.fillText(`${points} PTS  ·  🔥 ${streak}-DAY STREAK`, W / 2, 660);
  ctx.fillStyle = "#cfcfcf"; ctx.font = "700 30px Arial, sans-serif";
  ctx.fillText("CENTRAL ILLINOIS  #1", W / 2, 715);
  ctx.fillStyle = "#777"; ctx.font = "600 24px Arial, sans-serif";
  ctx.fillText("NEXT O SOCCER · ELITE TECHNICAL TRAINING", W / 2, H - 90);
  const dataUrl = c.toDataURL("image/png");

  const w = window.open("", "_blank");
  if (!w) { toast.error("Allow pop-ups to open the card."); return; }
  const fileName = `next-o-potw-${(name || "winner").toLowerCase().replace(/[^a-z0-9]+/g, "-")}.png`;
  w.document.write(`<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1,viewport-fit=cover"/><title>Player of the Week</title>
<style>*{box-sizing:border-box}body{margin:0;font-family:Arial,sans-serif;background:#0a0a0a;color:#fff}
.tb{position:sticky;top:0;display:flex;gap:10px;flex-wrap:wrap;align-items:center;padding:calc(env(safe-area-inset-top,0px)+14px) 18px 14px;background:rgba(13,13,13,.85);backdrop-filter:blur(14px);border-bottom:1px solid rgba(255,255,255,.1)}
.btn{display:inline-flex;align-items:center;gap:8px;border:1px solid rgba(255,255,255,.18);background:rgba(255,255,255,.06);color:#fff;font-weight:800;text-transform:uppercase;letter-spacing:1px;font-size:12px;padding:11px 16px;border-radius:8px;cursor:pointer}
.btn.gold{background:#D4AF37;color:#111;border-color:#D4AF37}.btn.close{margin-right:auto}
.stage{display:flex;justify-content:center;padding:26px 16px 60px}img{width:100%;max-width:480px;border-radius:16px;box-shadow:0 20px 60px rgba(0,0,0,.6)}
@media print{.tb{display:none}.stage{padding:0}img{max-width:100%;border-radius:0}}</style></head><body>
<div class="tb"><button class="btn close" onclick="window.close()">‹ Close</button>
<button class="btn gold" id="s">⬇ Save Image</button><button class="btn" id="sh">↗ Share</button></div>
<div class="stage"><img src="${dataUrl}" alt="Player of the Week"/></div>
<script>
var D=${JSON.stringify(dataUrl)},F=${JSON.stringify(fileName)},T=${JSON.stringify(`${name} is Next O Soccer's Player of the Week! 🏆`)};
function b(d){var a=d.split(','),m=a[0].match(/:(.*?);/)[1],x=atob(a[1]),n=x.length,u=new Uint8Array(n);while(n--){u[n]=x.charCodeAt(n)}return new Blob([u],{type:m})}
document.getElementById('s').onclick=function(){var a=document.createElement('a');a.href=D;a.download=F;document.body.appendChild(a);a.click();a.remove()};
document.getElementById('sh').onclick=async function(){try{var f=new File([b(D)],F,{type:'image/png'});if(navigator.canShare&&navigator.canShare({files:[f]})){await navigator.share({files:[f],title:T,text:T});return}if(navigator.share){await navigator.share({title:T,text:T});return}await navigator.clipboard.writeText(T);alert('Copied: '+T)}catch(e){}};
<\/script></body></html>`);
  w.document.close();
}
